// ============================================
// AuthSync Component
// Синхронизирует пользователя из TanStack Query в Zustand store
// Это исправляет проблему "Firebase not available or no user"
// ============================================

import { useEffect } from 'react';
import { useAuth } from '../hooks/auth';
import { useStore } from '../store';

export function AuthSync() {
  const { user, isAuthenticated } = useAuth();
  const setUser = useStore((state) => state.setUser);
  const logout = useStore((state) => state.logout);
  const storeUser = useStore((state) => state.user);

  useEffect(() => {
    console.log('[AuthSync] Sync effect triggered:', {
      isAuthenticated,
      hasQueryUser: !!user,
      hasStoreUser: !!storeUser,
      queryUserId: user?.id,
      storeUserId: storeUser?.id
    });

    if (isAuthenticated && user) {
      // Only update if user changed
      if (!storeUser || storeUser.id !== user.id) {
        console.log('[AuthSync] Setting user in Zustand store:', user);
        setUser(user);
      }
    } else if (!isAuthenticated && storeUser) {
      // User logged out - clear store
      console.log('[AuthSync] Clearing user from Zustand store');
      logout();
    }
  }, [user, isAuthenticated, setUser, logout, storeUser]);

  // This component doesn't render anything
  return null;
}
